import React from "react"
import logo from "../images/preferenceslogo.png"
import background from "../images/preferencesbg.jpg"

const LandingPage = () => {
    return (
        <div className='flex justify-center items-center min-h-screen' 
    style={{
      backgroundImage: `url(${background})`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      backgroundPosition: "center"
      }}>
        <div className='bg-white p-5 rounded-sm shadow-lg max-w-[95%] md:max-w-lg w-full'>
            <img src={logo} className='mb-5' alt="Logo"/>
            <h1 className='text-4xl mb-4 text-chestertons-purple'>Thank you for subscribing!</h1>
        </div>
     
      </div>
        
    )
}

export default LandingPage;